import { Button, Divider, Card, TextArea } from '@blueprintjs/core';
import { comment } from '@axo/shared/data-access/types';
import { CreatorTag, CommentIcon, CreatedAtTag } from '../CommunicationItem';
import cardClasses from '../CommunicationItem/Card.module.css';
import { useCallback, useState } from 'react';
import { FollowUpModal } from '../../FollowUp/FollowUpModal';

import styles from './CommentCardEdit.module.css';

interface ICommentCardEdit {
  comment: comment.CreateComment;
  setComment: (comment: comment.CreateComment) => void;
  saveComment: () => void;
  cancelComment: () => void;
}

export function CommentCardEdit({
  comment,
  setComment,
  saveComment,
  cancelComment,
}: ICommentCardEdit) {
  const [isFollowUpModalVisible, setIsFollowUpModalVisible] = useState(false);

  const onValueChange = (name: keyof comment.CreateComment, value: string) => {
    setComment({
      ...comment,
      [name]: value,
    });
  };

  const _onSetFollowUpButtonClick = useCallback(() => {
    setIsFollowUpModalVisible(true);
  }, [setIsFollowUpModalVisible]);

  const _onCloseFollowUpModal = useCallback(() => {
    setIsFollowUpModalVisible(false);
  }, [setIsFollowUpModalVisible]);

  return (
    <>
      <Card className={cardClasses.card}>
        <div className={cardClasses.topBar}>
          <CommentIcon />
          <CreatorTag creatorID={comment.OwnerID} />
          {comment.CreatedAt && (
            <CreatedAtTag label="Commented at:" createdAt={comment.CreatedAt} />
          )}
          <div className={cardClasses.fill} />
        </div>
        <Divider />
        <div className={cardClasses.body}>
          <TextArea
            name="comment-textarea"
            onChange={(e) => onValueChange('Body', e.target.value)}
            value={comment.Body}
            placeholder="Write your custom comment..."
          />
          <Button
            onClick={_onSetFollowUpButtonClick}
            variant="minimal"
            className={styles.followUpButton}
            textClassName={styles.followUpButton__text}
          >
            Set follow up time
          </Button>
        </div>
        <Divider />
        <div className={cardClasses.bottomRow}>
          <div className={cardClasses.fill} />
          <Button
            icon="cross"
            onClick={cancelComment}
            minimal
            outlined
            intent="danger"
          >
            Discard
          </Button>
          <Button
            icon="tick"
            onClick={saveComment}
            minimal
            outlined
            intent="primary"
          >
            Save
          </Button>
        </div>
      </Card>
      {isFollowUpModalVisible && (
        <FollowUpModal onClose={_onCloseFollowUpModal} />
      )}
    </>
  );
}
